import { ConnectionLineComponentProps, getSmoothStepPath } from "@xyflow/react";
import { memo } from "react";

export const CustomConnectionLine = memo(function CustomConnectionLine({
  fromX,
  fromY,
  fromPosition,
  toX,
  toY,
  toPosition,
}: ConnectionLineComponentProps) {
  const [edgePath] = getSmoothStepPath({
    sourceX: fromX,
    sourceY: fromY,
    sourcePosition: fromPosition,
    targetX: toX,
    targetY: toY,
    targetPosition: toPosition,
    borderRadius: 20,
  });

  return (
    <g>
      <path
        d={edgePath}
        fill="none"
        stroke="black"
        strokeDasharray="5 5"
        strokeLinecap="butt"
        strokeWidth={2}
        style={{ animation: "dashdraw 0.5s linear infinite" }}
      />
    </g>
  );
});
